<template>
  <div>
    <div v-if="btnSpin === false">
      <v-btn :color="ui.btnColor" flat dark
       @click="getUserData()"
      >
        <v-icon left>person</v-icon>
        Info
      </v-btn>
    </div>
    <div v-else>
      <BtnSpin :btnSpec="btnInfo1"/>
    </div>
    <v-dialog v-model="dialog" persistent :max-width="ui.sizeWidthDialogLarge">
      <v-card :color="ui.cardColor">
        <v-card-title>
          <v-icon large left :color="ui.iconColor"> person </v-icon>
          <span :class="ui.textTitle"> {{this.localForm.username}} </span>
        </v-card-title>
        <v-card-text>
          <v-container :class="ui.bkgdColor">
            <v-layout row wrap class="ml-2 mr-2">
              <v-flex xs10>
                <v-text-field
                v-model="localForm.useremail"
                prepend-icon="mail"
                hint="email"
                persistent-hint
                readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs10>
                <v-text-field
                v-model="localForm.userphone"
                prepend-icon="phone"
                hint="phone"
                persistent-hint
                readonly
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap class="ml-2 mr-2">
              <v-flex xs10>
                <v-text-field
                v-model="localForm.lcountry"
                prepend-icon="public"
                hint="country"
                persistent-hint
                readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs10>
                <v-text-field
                v-model="localForm.lstate"
                prepend-icon="image"
                hint="state"
                persistent-hint
                readonly
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap class="ml-2 mr-2">
             <v-flex xs10>
               <v-text-field
               v-model="localForm.rpos"
               prepend-icon="work_outline"
               hint="role"
               persistent-hint
               readonly
               ></v-text-field>
             </v-flex>
             <v-flex xs10>
               <v-text-field
               v-model="localForm.rtrade"
               prepend-icon="engineering"
               hint="trade or profession"
               persistent-hint
               readonly
               ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap class="ml-2 mr-2">
              <v-flex xs10>
                <v-text-field
                v-model="localForm.rctitle"
                prepend-icon="account_balance"
                hint="employer"
                persistent-hint
                readonly
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn
          @click="closeDialog()" :color="ui.btnColor" flat>
            <v-icon left> exit_to_app </v-icon>
            Close
          </v-btn>
          <v-spacer/>
          <v-btn
          :color="ui.btnColor" flat>
            <v-icon left> check_circle_outline </v-icon>
            {{localForm.verify}}
          </v-btn>
          <v-btn
          :color="ui.btnColor" flat>
            <v-icon left> fingerprint </v-icon>
            {{this.displayDocumentIDGTypeA("U1", this.localForm.useridg)}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import apptheme from "@/frame/theme/mixins/apptheme.js";
import BtnSpin from "@/frame/animation/components/BtnSpin";
import numberFunctions from "@/data/functions/mixins/numberFunctions.js";
// import describeDocument from "@/data/describe/mixins/describeDocument";
import getData from "@/data/cloud/firebase/mixins/getData.js";
import displayFunctions from "@/data/functions/mixins/displayFunctions.js";
import { mapGetters } from "vuex";
// import TransitionsStage from "@/support/transitions/components/TransitionsStage";
export default {
  props: {
    data: {
      type: Object
    }
  },
  components: {
    BtnSpin
  },
  watch: {
    dataSaved() {
      if (this.ctr === 1) {
        this.ctr = this.ctr + 1;
        console.log("Open ONCE ONLY");
        this.dialog = true;
      }
    }
  },
  mixins: [apptheme, numberFunctions, getData, displayFunctions],
  data() {
    return {
      valid: true,
      dialog: false,
      ctr: 0, // this prevent bounce that lead to overstack limt
      btnSpin: false,
      btnInfo1: {
        color: "red",
        icon: "person",
        name: "add user",
        btnType: "flat"
      },
      localForm: {
        username: "",
        useremail: "",
        userphone: "",
        useridg: "",
        lcountry: "", // company or facility
        lstate: "", // company or facility
        rtrade: "",
        rpos: "",
        rdes: "",
        verify: ""
      }
    };
  },
  updated() {
    // fix orginal data before change
    if (this.getInfoCard !== null) {
      this.localForm.username = this.getInfoCard.basic.title;
      this.localForm.useremail = this.getInfoCard.basic.email;
      this.localForm.useridg = this.getInfoCard.basic.idg;
      this.localForm.userphone = this.getInfoCard.char.ppri;

      this.localForm.lcountry = this.getInfoCard.char.lcountry;
      this.localForm.lstate = this.getInfoCard.char.lstate;

      this.localForm.rtrade = this.getInfoCard.char.rtype;
      this.localForm.rpos = this.getInfoCard.char.rpos;
      this.localForm.rdes = this.getInfoCard.char.rdes;
      this.localForm.rctitle = this.getInfoCard.char.rct;

      this.localForm.verify = this.getInfoCard.basic.verify;
    }
  },
  computed: {
    ...mapGetters(["getInfoCard"]),
    dataSaved() {
      let saved = false;
      if (this.getInfoCard !== null && this.ctr === 1) {
        saved = true;
        // this.ctr = this.ctr + 1;
      } else {
        saved = false;
      }
      return saved;
    }
  },
  methods: {
    closeDialog() {
      // reset store
      // this.$store.dispatch("changeUserSec", null);
      this.btnSpin = false;
      this.dialog = false;
      this.ctr = 0;
    },
    getUserData() {
      if (this.ctr === 0) {
        this.ctr = this.ctr + 1;
        this.btnSpin = true;
        this.getDocumentInfoCard("U1", this.data.char.udid);
      }
    }
  }
};
</script>
